import EducationList from "../views/EducationList"
import CourseDetail from "../views/CourseDetail"
import CourseContent from "../views/CourseContent"

export default [
	{
		path: "/:tenantId/education",
		component: EducationList,
		name: "EducationList",
		meta: { featureId: "education" },
		props: true
	},
	{
		path: "/:tenantId/education/detail/:id",
		component: CourseDetail,
		name: "CourseDetail",
		meta: { featureId: "education" },
		props: true
	},
	{
		path: "/:tenantId/education/detail/:id/content",
		component: CourseContent,
		name: "CourseContent",
		meta: { featureId: "education" },
		props: true
	}
]
